<template>
	<div class="mute-btn">
		<a href="#" class="speaker-icon" :class="{ muted: muted }" @click.prevent="toggleMute">
			<svg class="speaker-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.9 25.69">
				<g id="speaker">
					<path d="M19.48.16,9.33,6.39v-.1H3a3,3,0,0,0-3,3v6.81a3.28,3.28,0,0,0,3.28,3.28H9L19.5,25.54a1.1,1.1,0,0,0,1.5-.39,1.19,1.19,0,0,0,.15-.55V1.09A1.09,1.09,0,0,0,20.05,0,1.14,1.14,0,0,0,19.48.16Z" fill="#fff"/>
				</g>
				<g id="waves">
					<path d="M30.86,5.37a1.32,1.32,0,0,0-1.8-.46L29,5a1.32,1.32,0,0,0-.4,1.78,12.39,12.39,0,0,1,0,12.37A1.34,1.34,0,0,0,29,20.83h0a1.32,1.32,0,0,0,1.84-.23l.09-.14a15.16,15.16,0,0,0-.05-15.1Z" fill="#fff"/>
					<path d="M24.37,7.43l-.19.16a1.2,1.2,0,0,0-.31,1.57A7.42,7.42,0,0,1,25,13,7.85,7.85,0,0,1,24,16.77a1.26,1.26,0,0,0,.2,1.53l.12.11A1.23,1.23,0,0,0,26,18.36a1.33,1.33,0,0,0,.14-.19,9.88,9.88,0,0,0,0-10.42,1.22,1.22,0,0,0-1.68-.39Z" fill="#fff"/>
				</g>
			</svg>
		</a>
	</div>
</template>

<script>
/* eslint max-len: ["error", { "code": 800, "tabWidth": 4 }] */

import { mapState, mapActions } from 'vuex';
import Vector from '@/components/abstract/Vector';

export default {
	name: 'MuteToggle',
	components: {
		Vector,
	},
	props: {
		eventCategory: {
			type: String,
			default: "Game",
		},
	},
	computed: {
		...mapState({
			muted: state => state.sound.muted,
		}),
	},
	methods: {
		...mapActions(["sendEvent"]),
		toggleMute() {
			this.$store.commit("toggleMute");
			this.sendEvent({
				ec: this.eventCategory,
				ea: "Mute",
				el: this.muted ? "Muted" : "Unmuted",
			});
		},
	},
};
</script>

<style lang="scss">
	.speaker-icon {
		display: inline-block;
		height: 25px;
		width: 25px;
		position: relative;
		overflow: hidden;

		@include mobile {
			// height: 44px;
			// width: 44px;
		}


		#waves {
			transition: all $ui-transition-duration;
		}

		&:hover {
			#waves {
				transform: translate(-10%, 0);
			}
		}

		&.muted {
			#waves {
				transform: translate(-50%, 0);
				opacity: 0;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/MuteToggle.vue